import React, { useEffect, useState } from 'react';
import { View, TouchableOpacity } from 'react-native';
import MyAppText from '../MyAppText';
import { translate } from '../../services/translate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { WindowInformation } from '../../services/window-information';
import { centralAPI } from '../../services/central-api';
import { InfoInRow } from '../InfoInRow';
import { faCalendarCheck, faLocationDot, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import Card from '../Card';
import { RootNavigation } from '../../Routes';
import { openInNewTab } from '../../services/navigation-assistant';

export function SchoolAppOccurrence({ occurrence, navigation }: { occurrence: Occurrence; navigation: RootNavigation; }) {
    const { styles, theme } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    const [address, setAddress] = useState<string>('');

    if (occurrence.triggerType !== 'school_app' || !occurrence.externalReference) {
        return <></>;
    }

    async function fetchAddress(pos: LatLng) {
        const address = await centralAPI.getAddressByPlace({ latitude: pos.lat, longitude: pos.lng });
        if (address) {
            setAddress(address);
        }
    }

    function occurrenceHasAddress() {
        return occurrence.address && occurrence.address != '';
    }

    useEffect(() => {
        if (!occurrenceHasAddress()) {
            fetchAddress({
                lat: occurrence.latitude,
                lng: occurrence.longitude
            });
        }
    }, [occurrence]);

    return (
        <View style={{ gap: 20 }}>
            <View style={{ gap: 5 }}>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <TouchableOpacity
                            onPress={() => {
                                if (occurrence.id) {
                                    openInNewTab('Dispatch', { screen: 'DispatchOccurrenceDetail', params: { occurrenceId: occurrence.id } });
                                }
                            }}
                            disabled={windowInfo.isMobile}
                        >
                            <MyAppText style={{ fontSize: 16, color: theme.colors.textColor, fontWeight: 'bold' }}>
                                {translate('nProtocol')}: {occurrence?.id}
                            </MyAppText>
                        </TouchableOpacity>
                        <MyAppText> </MyAppText>
                        <MyAppText style={{ fontSize: 14, color: theme.colors.textColor }}>
                            ({translate('team')} {translate(occurrence.OccurrenceUnits?.length && occurrence.OccurrenceUnits[0].OccurrenceUnit.isStarter ? 'starter' : 'support').toLowerCase()})
                        </MyAppText>
                    </View>
                    <TouchableOpacity onPress={() => navigation.navigate('AppAgent', { screen: 'AgentOccurrences' })}>
                        <FontAwesomeIcon color={theme.colors.iconColor} fontSize={30} icon={faTimes as IconDefinition} />
                    </TouchableOpacity>
                </View>
                <MyAppText style={styles.alertText}>
                    {translate('schoolAppAlert')}
                </MyAppText>
            </View>
            <Card>
                <View style={{ gap: 15 }}>
                    <View style={{ gap: 3 }}>
                        <MyAppText style={styles.text}>{translate('location')}</MyAppText>
                        <>
                            <InfoInRow value={moment(new Date(occurrence.createdAt)).format('DD/MM/YYYY HH:mm:ss')} fontAwesomeIcon={faCalendarCheck} />
                            <InfoInRow value={address} fontAwesomeIcon={faLocationDot} />
                        </>
                    </View>
                </View>
                <View>
                    <InfoInRow title={'occurrenceId'} value={occurrence.id} />
                    <InfoInRow title={'priority'} valueStyle={occurrence.priority === 'maximum' ? { color: '#FF0027' } : undefined} value={occurrence.priority ? translate(occurrence.priority) : ''} />
                    <InfoInRow title={'narrative'} value={occurrence.narrative} />
                </View>
            </Card>
        </View>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    visualizedRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5
    },
    detectionInfoText: {
        color: theme.colors.textColor,
        fontSize: 12
    },
    text: {
        color: theme.colors.textColor,
        fontWeight: 'bold',
        fontSize: 16
    },
    alertText: {
        color: theme.colors.textColor,
        fontSize: 16,
        fontWeight: 'bold',
    },
    cardText: {
        color: theme.colors.textColor,
        fontSize: 12
    },
    cardBoldText: {
        color: theme.colors.textColor,
        fontWeight: 'bold',
        fontSize: 14
    },
}));
